"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignPaymentValidation = void 0;
class AssignPaymentValidation {
    static isValid(entity) {
        // Validate entity.port_id for existence and correct type.
        if (entity.port_id == undefined)
            return false;
        if (typeof entity.port_id !== "number")
            return false;
        return true;
    }
}
exports.AssignPaymentValidation = AssignPaymentValidation;
